import image from '@/assets/images/manufacturers/network-analyzer.png';
import { option } from '@/util/container';
import { MANUFACTURERS } from '..';

export default option(MANUFACTURERS, async () => ({
  name: 'Network Analyzer',
  label: 'Network Analyzer',
  image,
}));
